<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="card">
            <div class="card-body mb-0 pb-0">
                <TabNavigation v-model="activeTab" :tabs="tabs" />
                <SportClubListing v-if="activeTab == 'sportClub'" class="fade-in" />
                <SportClubSportTypeListing v-else-if="activeTab == 'sportClubSportType'" class="fade-in" />
                <SportClubBoardTypeListing v-else-if="activeTab == 'sportClubBoardType'" class="fade-in" />
            </div>
        </div>
    </Layout>
</template>
<script>
import TabNavigation from '@/components/customTopNav';
import SportClubSportTypeListing from '@/views/pages/admin/sportClubSportType/sportClubSportTypeListing';
import SportClubBoardTypeListing from '@/views/pages/admin/sportClubBoardType/sportClubBoardTypeListing';
import Layout from '@/views/layouts/main';
import PageHeader from '@/components/page-header';
import i18n from '@/i18n';
import SportClubListing from '@/views/pages/admin/sportClub/sportClubListing';

export default {
    page: {
        title: i18n.t('module.sportClub'),
    },
    components: { Layout, PageHeader, SportClubListing, SportClubSportTypeListing, SportClubBoardTypeListing, TabNavigation },
    data() {
        return {
            title: i18n.t('module.sportClub'),
            activeTab: 'sportClub',
            tabs: [
                { id: 'sportClub', name: i18n.t('module.sportClub'), icon: 'mdi-account-group-outline' },
                { id: 'sportClubSportType', name: i18n.t('module.sportClubSportType'), icon: 'mdi-basketball' },
                { id: 'sportClubBoardType', name: i18n.t('module.sportClubBoardType'), icon: 'mdi-account-tie-outline' },
            ],
            items: [
                {
                    text: i18n.t('module.communication'),
                    href: '/communications',
                },
                {
                    text: i18n.t('module.sportClub'),
                    active: true,
                },
            ],
        };
    },
};
</script>
